import React from 'react';

import styles from './styles.module.scss';

const Content = ({ children, className = '' }) => (
    <div className={`${styles.cardContent} ${className}`}>{children}</div>
);

export default Content;
